import './Spinner.css';

// pathLength 100 makes the dash keyframes percentages of the circle. The viewBox
// scales with the element, so CSS can resize it and the stroke keeps its proportion.
export default function Spinner({ size = 50, strokeWidth = 4, color = "#0000C8", className, label = "Laster" }:
    { size?: number, strokeWidth?: number, color?: string, className?: string, label?: string }) {
    return (
        <svg className={"mer-spinner" + (className ? " " + className : "")} width={size} height={size}
             viewBox={`0 0 ${size} ${size}`} style={{ color }} role="status" aria-label={label}>
            <circle className="mer-spinner__arc" cx={size / 2} cy={size / 2} r={(size - strokeWidth) / 2}
                    strokeWidth={strokeWidth} pathLength={100} />
        </svg>
    );
}
